<template>
    <div class="border rounded p-2 shadow mb-2">
        <h4>Фильтры:</h4>
        <div v-for="p in internalList" class="row px-3" :key="p.id">
            <label class="col-form-label"> <span>Поле:</span></label>
            <div class="col-md-5 d-flex form-group">
                <el-select 
                    class="select-primary mr-2"
                    :value="p.name" 
                    placeholder="Укажите поле"
                    @input="updateProp(p.id, 'name', $event)"
                    size="large"
                    filterable
                    clearable
                >
                    <el-option
                        class="select-primary"
                        v-for="m of filterProps"
                        :key="m"
                        :label="m"
                        :value="m"
                        >
                    </el-option>
                </el-select>
            </div>
            <label class="col-form-label"> <span>Значение:</span></label>
            <div class="col-md-5 form-group">
				<div class="mb-0">
					<input type="text" class="form-control" :value="p.value" @input="updateProp(p.id, 'value', $event.target.value)" placeholder="Список вариантов через запятую">
				</div>		
			</div>
            <base-button type="danger" class="my-0" simple icon v-on:click="remove(p)"><i class="d-inline-block tim-icons icon-simple-remove"></i></base-button>
        </div>

        <div class="dflex">
            <base-button class="sm" type="success" simple  @click="Add()">Добавить фильтр</base-button>
        </div>
    </div>
</template>
<script>
import { Select, Option, Button } from 'element-ui';

export default {
    components:{
        [Option.name]: Option,
        [Select.name]: Select,
    },
    props: {
        value: {
            type: Array,
            required: true,
            default: () => []
        },
        filterProps:{
            type: Array,
            default(){ return []},
        },
    },
    data() {
        return {
            internalList: this.value.map(obj => ({ ...obj })),
            types:{
                string:'Строка',
                integer:'Число',
                number:'Вещественное',
                boolean:'Логический',
                enum:'Перечисление',
                date:'Дата',
                datetime:'Дата и Время',
                time:'Время',
                arrayString:'массив строк',
                arrayInt:'Массив чисел',
                arrayEnum:'Массив перечислений',
                // test_callView:'Звонок или встреча',
            },
        }
    },
    watch: {
        value: {
            handler(newVal) {
                // Синхронизируем при внешнем изменении
                this.internalList = newVal.map(obj => ({ ...obj }))
            },
            deep: true
        }
  },
  methods: {
    updateList(newValue){
        this.internalList = newValue;
        this.$emit('input', newValue);
    },
    Add(){
        const newProp = {
            id: this.$GVO.getId(), // или получите из props, или используйте внешнюю функцию
            name: '',
            value: '',
        };

        const updatedList = [...this.internalList, newProp];
        this.updateList(updatedList);

    },
    remove(p) {
        const index = this.internalList.indexOf(p);
        if (index === -1) return;

        // Создаём новый массив БЕЗ удаляемого элемента
        const updatedList = [
            ...this.internalList.slice(0, index),
            ...this.internalList.slice(index + 1)
        ];
        
        this.updateList(updatedList);

    },
    updateProp(id, field, newValue) {
      const index = this.internalList.findIndex(item => item.id === id);
      if (index === -1) return;

      // Создаём обновлённый объект
      const updatedItem = { ...this.internalList[index], [field]: newValue };

      // Создаём новый массив
      const updatedList = [
        ...this.internalList.slice(0, index),
        updatedItem,
        ...this.internalList.slice(index + 1)
      ];

      this.updateList(updatedList);
    },
  }
}
</script>